<ng-container *ngIf="loader">
    <div class="widget-loading" *ngFor="let i of [1];" style="height:150px">
      <p><i nz-icon nzType="loading" theme="outline"></i>&nbsp; Loading Medical Report Summary...</p>
    </div>
  </ng-container>

<div *ngIf="!showLabReportSummary && !loader">
    <div class="m-b-20" *ngIf="requirementList.length > 0; else showNoLabRequirementMessage">

        <div class="heading-tab"  style="border-bottom: 0px;">
            <h3 class="heading"><em nz-icon nzType="file-done" nzTheme="outline"></em> Medical Report Requirements
            </h3>
        </div>

        <nz-collapse>
            <nz-collapse-panel *ngFor="let requirement of requirementList; let reqIndex = index;"
                [nzHeader]="requirement.requirementCd == 'LABTEST' ? 'Summary of Medical Reports' : requirement.requirementCd" [nzActive]="reqIndex == 0">

                <div>
                    
                    <div>
                        <button *ngIf="enableAddUpdateLabReport" id="uploadButton" nz-button (click)="showDocumentUploadPopup(requirement);" class="m-t-10 d-i-b">
                            <span><em nz-icon nzType="upload" class="anticon anticon-upload"></em> Add/Update Lab Reports</span>
                        </button>
                    </div>

                    <div class="" *ngIf="selectedOCRDataList && selectedOCRDataList.length > 0">
                        <div class="w-100-pc">
                            <ng-container *ngIf="false" class="flexie-auto-grid">
                                <h4  style="font-size: 18px; font-weight: bold;">
                                    <span>Summary of Medical Reports</span>
                                </h4>                         
                            </ng-container>

                            <ng-container *ngFor="let OCRDocData of fetchedAllDocumentOCRDataList">
                                <div *ngIf="OCRDocData.summary; else noSummaryMessage" class="medicalSummarySec">
                                    <div class="m-b-5">
                                        Summary:
                                    </div>
                                    {{OCRDocData.summary}}
                                </div>
                            </ng-container>

                            <nz-table *ngIf="selectedOCRDataList && selectedOCRDataList.length" #selectedReportData [nzData]="selectedOCRDataList" nzSize="small" class="d-b" [nzScroll]="{x: '480px'}"
                                class="table-valign-top"
                                [nzFrontPagination]="true"
                                [nzPageSize]="mapperTablePageSize"
                                [nzPageIndex]="mapperTableIndex">
                                <thead>
                                    <tr>
                                        <th style="width:40px"></th>
                                        <th>Test</th>
                                        <th>Result</th>
                                        <th>Unit</th>
                                        <th>Normal Range</th>
                                        <!-- <th>Action</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- <tr *ngFor="let u of selectedReportData.data let i=index" [style.background-color]="(u.referenceMinValue !== null && u.referenceMaxValue !== null && (u.value < u.referenceMinValue || u.value > u.referenceMaxValue )|| u.result === 'Positive') ? '#FFCCCB' : 'transparent'" -->
                                        <!-- > -->
                                        <tr *ngFor="let u of selectedReportData.data let i=index" [style.background-color]="(u.result == 'ABNORMAL') ? '#FFCCCB' : 'transparent'">
                                        <td>
                                            <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small"
                                                nzIcon="check"></nz-avatar>
                                        </td>
                                        <td style="color:#1890ff;">{{u.testCd}}</td>
                                        <td>{{u.value}}</td>
                                        <td>{{u.measureUnitCd}}</td>
                                        <td>{{u.referenceMinValue}} - {{u.referenceMaxValue}} {{u.referenceMeasureUnitCd}}
                                        </td>
                                        <!-- <td>
                                            <a>Rectify Value</a>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </nz-table>
                        </div>
                    </div>

                </div>
            </nz-collapse-panel>
        </nz-collapse>
    </div>
</div>

<!-- Show Summary for Proposal Review -->
<div class="m-b-20 m-t-10 p-10" style="background: #fff;" *ngIf="showLabReportSummary && !loader && fetchedAllDocumentOCRDataList && fetchedAllDocumentOCRDataList.length">
    <ng-container *ngFor="let OCRDocData of fetchedAllDocumentOCRDataList">
        <div class="" style="border-bottom: 0px;">
            <h3 class="heading" style="font-size:medium"><em nz-icon nzType="file-done" nzTheme="outline"></em> Summary
            </h3>
        </div>
        <div *ngIf="OCRDocData.summary; else noSummaryMessageForReview" class="medicalSummarySec">
            {{OCRDocData.summary}}
        </div>
        <ng-template #noSummaryMessageForReview>
            <!-- <nz-alert class="m-t-b-15" nzType="info" nzMessage="The summary of the uploaded report document will appear here."></nz-alert> -->
            <nz-result nzStatus="info" nzTitle="There are no any lab test reports uploaded. Please upload documents." nzSubTitle="Please contact administrator if the issue persists.">
            <!-- <div nz-result-extra> <button nz-button nzType="primary">Back Home</button> </div> -->
        </nz-result>
        </ng-template>
        <nz-table *ngIf="selectedOCRDataList && selectedOCRDataList.length" #selectedReportData [nzData]="selectedOCRDataList" nzSize="small" class="d-b" [nzScroll]="{x: '480px'}"
        class="table-valign-top"
        [nzFrontPagination]="selectedOCRDataList.length > 5 ? true : false"
        [nzPageSize]="mapperTablePageSize"
        [nzPageIndex]="mapperTableIndex">
        <thead>
            <tr>
                <th style="width:40px"></th>
                <th>Test</th>
                <th>Result</th>
                <th>Unit</th>
                <th>Normal Range</th>
                <!-- <th>Action</th> -->
            </tr>
        </thead>
        <tbody>
            <!-- <tr *ngFor="let u of selectedReportData.data let i=index" [style.background-color]="(u.referenceMinValue !== null && u.referenceMaxValue !== null &&(u.value < u.referenceMinValue || u.value > u.referenceMaxValue ) || u.result === 'Positive') ? '#FFCCCB' : 'transparent'"> -->
                <tr *ngFor="let u of selectedReportData.data let i=index" [style.background-color]="(u.result == 'ABNORMAL') ? '#FFCCCB' : 'transparent'">
                <td>
                    <nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="small"
                        nzIcon="check"></nz-avatar>
                </td>
                <td style="color:#1890ff;">{{u.testCd}}</td>
                <td>{{u.value}}</td>
                <td>{{u.measureUnitCd}}</td>
                <td>{{u.referenceMinValue}} - {{u.referenceMaxValue}} {{u.referenceMeasureUnitCd}}
                </td>
                <!-- <td>
                    <a>Rectify Value</a>
                </td> -->
            </tr>
        </tbody>
        </nz-table>
    </ng-container>

   
</div>

<ng-template #showNoLabRequirementMessage>
    <nz-alert class="m-b-20" nzType="info" nzMessage="No lab report requirement has been generated."></nz-alert>
</ng-template>

<!-- Upload Report Popup -->
<nz-modal [(nzVisible)]="uploadReportModal" nzTitle="Lab Reports" nzOkText="Update" nzClosable="true" nzKeyboard="false" nzMaskClosable="false"
    (nzOnOk)="validateData()" [nzOkDisabled]="!fetchedAllDocumentOCRDataList || fetchedAllDocumentOCRDataList.length == 0" (nzOnCancel)="uploadReportModal=false" nzWidth="90%">
    <ng-container *nzModalContent>
    <div>
        <!-- <nz-spin [nzSpinning]="processingOCR" nzTip="Processing OCR..."> -->
        <div class="grid grid-2x grid-gap-20">
            <div>

                <div class="heading-tab">
                    <h3 class="heading"><em nz-icon nzType="profile"></em> Reports</h3>
                    <!-- <button nz-button nzType="primary" (click)="OCRprocessBill()">Re-Scan OCR</button> -->
                </div>

                <div class="has-ocr">
                    <!-- <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/"
                         [nzFileList]="fileList"
                         nzListType="picture-card"
                         [nzPreview]="handlePreview"
                         [nzRemove]="handlePreview"
                         [className]="'has-ocr'"
              >
                <i nz-icon nzType="plus"></i>
                <div class="ant-upload-text">Upload</div>
              </nz-upload> [nzDisabled]="fileList.length >= 3" -->
                    <!-- <nz-alert class="m-b-20" nzType="info" nzMessage="Maximum 3 documents can be uploaded."></nz-alert> -->
                    <nz-upload [nzFileList]="labReportDocuments" [nzBeforeUpload]="fileUploadBefore"
                        [nzShowUploadList]="showUploadList" nzListType="picture-card"
                        [nzPreview]="handlePreview" class="has-ocr"> 
                        <div id="uploadId" class="ant-upload-text"
                            (click)="setUploadParams(current_requirementObj_for_uploading_report,0, clientRefGuid)"> Upload
                        </div>
                        <!-- <button nz-button  [nzFileList]="fetchedAllDocumentOCRDataList" (click)="setUploadParams(current_requirementObj_for_uploading_report,0, clientRefGuid)">
                            <span nz-icon nzType="upload"></span>
                            Upload
                          </button> -->
                    </nz-upload>
                    <!-- <nz-upload  [nzFileList]="labReportDocuments">
                        <button nz-button  (click)="setUploadParams(current_requirementObj_for_uploading_report,0, clientRefGuid)">
                          <span nz-icon nzType="upload"></span>
                          Upload
                        </button>
                      </nz-upload> -->
                    <!-- <button id="uploadId" nz-button (click)="setUploadParams(current_requirementObj_for_uploading_report,0, clientRefGuid)" class="m-t-10 d-i-b">
                        <span><i nz-icon nzType="upload" class="anticon anticon-upload"></i> Upload</span>
                    </button> -->
                    <div class="m-t-10" *ngFor="let dc of documentCollection">
                        <ng-container *ngFor="let file of dc.documents; let ind=index;">
                            <div *ngIf="file.documentTypeCd == 'LABTEST'"><a (click)="fetchDocumentData(file.guid)"> <em class="m-r-5" nz-icon nzType="paper-clip" nzTheme="outline"></em> {{file.entityImageName}}</a></div>
                            <!-- <em class="m-l-5" nz-icon nzType="delete" nzTheme="outline"></em> -->
                        </ng-container>
                    </div>

                    <nz-spin [nzSpinning]="generatingMedicalSummary" nzTip="Generating Summary..." style="min-height: 100px;">
                        <div *ngIf="medicalSummary" class="medicalSummarySec">
                            <div class="m-b-5">
                                Summary:
                            </div>
                            {{medicalSummary}}
                        </div>
                    </nz-spin>
                    <ng-container *ngFor="let OCRDocData of fetchedAllDocumentOCRDataList">
                        <div *ngIf="OCRDocData.summary && currentOCRDocumentGuid == OCRDocData.documentGuid; else noSummaryMessage" class="medicalSummarySec">
                            <div class="m-b-5">
                                Summary:
                            </div>
                            {{OCRDocData.summary}}
                        </div>
                    </ng-container>
                    

                    <ng-template #noSummaryMessage>
                        <nz-alert class="m-t-b-15" nzType="info" nzMessage="The summary of the uploaded report document will appear here."></nz-alert>
                    </ng-template>

                    <img *ngIf="previewImgSrc" [src]="previewImgSrc" class="w-100-pc" alt="report"/>
                    <div *ngIf="showPDF && dataTransformService.documentPreview && dataTransformService.documentPreview.dataStream">
                        <span>{{dataTransformService.documentPreview['fileName']}}</span>
                        <span>{{dataTransformService.documentPreview.dataStream}}</span>
                        <app-ui-draggable-modal [documentPreviewData]="dataTransformService.documentPreview" [dragBoxConfig]="draggableBoxes"></app-ui-draggable-modal>
                        <!-- <pdf-viewer [src]="dataTransformService.documentPreview.dataStream" [render-text]="false" style="display: block; min-width:840px">
                        </pdf-viewer> -->
                    </div>

                </div>
            </div>

            <!-- DATA TABLE -->
            <div *ngIf="fetchedAllDocumentOCRDataList && fetchedAllDocumentOCRDataList.length > 0">
                <ng-container *ngFor="let OCRDocData of fetchedAllDocumentOCRDataList">
                   <ng-container *ngIf="currentOCRDocumentGuid == OCRDocData.documentGuid">
                    <div class="heading-tab">
                        <h3 class="heading"><em nz-icon nzType="file-done" nzTheme="outline"></em> {{OCRDocData.entityImageName}}
                        </h3>
                        <!-- <button nz-button nzType="primary" (click)="saveUpdateOCRData()">Update Data</button> -->
                        <!-- <button nz-button nzType="primary" (click)="updateAllOCRData()">Update Data</button> -->
                    </div>
                    <div *ngIf="OCRDocData && OCRDocData.labTestResults && OCRDocData.labTestResults.length > 0">
                        <div class="heading-tab">
                            <!-- <button nz-button nzType="primary" (click)="importSelected()">Import Selected</button> -->
                        </div>
                        <nz-table #OCRDataTable [nzData]="OCRDocData.labTestResults" [nzScroll]="{ x: '580px' }"
                            class="table-valign-top" [nzSize]="'small'"
                            [nzFrontPagination]="true"
                            [nzPageSize]="mapperTablePageSize"
                            [nzPageIndex]="mapperTableIndex">
                            <thead>
                                <tr>
                                    <th style="width:40px"></th>
                                    <th style="width: 230px">Test</th>
                                    <th style="width: 230px">Result</th>
                                    <th style="width: 120px">Units</th>
                                    <th style="width: 120px">Normal Range</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <ng-container *ngIf="let data of filteredSelectedOCRData()"></ng-container> -->
                                <!-- <tr *ngFor="let res of OCRDataTable.data; let i=index;" [style.background-color]="(res.referenceMinValue !== null && res.referenceMaxValue !== null &&(res.value < res.referenceMinValue || res.value > res.referenceMaxValue ) || res.result === 'Positive') ? '#FFCCCB' : 'transparent'"> -->
                                    <tr *ngFor="let res of OCRDataTable.data; let i=index;" [style.background-color]="(res.result == 'ABNORMAL') ? '#FFCCCB' : 'transparent'">
                                    <td class="text-a-center">
                                        <label nz-checkbox [nzValue]="res" [(ngModel)]="res.summaryFl"></label>
                                    </td>
                                    <td [ngClass]="{'inputs-are-disabled':res.duplicate}">
                                        <input type="text" nz-input placeholder="Test name" nzSize="default"
                                            [(ngModel)]="res.testCd" style="max-width: 160px" class="text-a-right" />
                                    </td>
                                    <td>
                                        <input type="text" nz-input placeholder="Result" nzSize="default" [(ngModel)]="res.value"
                                            style="max-width: 160px" class="text-a-right" />
                                    </td>
                                    <td>
                                        {{res.measureUnitCd}}
                                    </td>
                                    <td>{{res.referenceMinValue}} - {{res.referenceMaxValue}} {{res.referenceMeasureUnitCd}}</td>
                                </tr>
                            </tbody>
                        </nz-table>
        
                    </div>
                   </ng-container>
                </ng-container>
            </div>
        </div>
        <!-- </nz-spin> -->
    </div>
    </ng-container>
    <!-- <div *nzModalFooter>
    <button nz-button nzType="default" (click)="uploadReportModal=false">Cancle</button>
    <button nz-button nzType="primary" (click)="validateData()">Validate Data</button>
    <button nz-button nzType="primary" (click)="updateAllOCRData()" [nzLoading]="isConfirmLoading">Update</button>
    </div> -->
</nz-modal>